import { RobotOffIcon } from './RobotOffIcon';

/**
 * author: Colton Wiscombe
 * id B62D8FF2-AF07-4D20-8C8B-93E585EF6EFB
 * name robot-off
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-off.svg
 * tags
 */
export const EmoticonRobotOffIcon = RobotOffIcon;
export default EmoticonRobotOffIcon